<template>
    <v-container class="pt-1 pb-1">
        <v-row>
            <v-col cols="12" class="pt-1 pb-1">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Lista de opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in options" :key="item.id">
                            <td>{{ item.option_name }}</td>
                        </tr>                        
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'VariantsOptions',
    props: ['options']
}
</script>